import { ReactElement } from "react";
import { BaseFilterProps } from "../../_types";
import { FilterComponent } from "../../base-filter";
import type { SapExportErrorCategoryFilter } from "./sap-export-error-category-filter";
import { useSapExportErrorCategoryFilterData } from "./use-sap-export-error-category-filter-data";

export const SapExportErrorCategoryFilterComponent = ({
  filter,
  ...props
}: { filter: SapExportErrorCategoryFilter } & BaseFilterProps): ReactElement => {
  const data = useSapExportErrorCategoryFilterData();

  const filterWithData = Object.create(filter);
  filterWithData.getData = () => data;

  return <FilterComponent filter={filterWithData} {...props} />;
};
